import { Box,  Typography,  } from '@mui/material';
import React from 'react';
import { getResponsiveHeight, getResponsiveSize } from '../../utils/responsive';
import globalStyles from '../../global';
import Footer from '../HomeComponent/Footer';
import EventDetails from '../EventComponent/EventDetails';
import LaundryLeaders from '../EventComponent/LaundryLeaders';
import News from '../globalCountries/countryhomepagescomponent/News';
import PastEventBanner from './PastEventBanner';
import FeedbackComponent from '../EventComponent/Feedback';
import UpcomingEventsCardsSection from '../EventComponent/upcomingeventcards'
import { useLocation } from 'react-router-dom';

const GlobalPastEvent = () => {
   const location = useLocation();
  const { event } = location.state || {}; 

  if (!event) return <div>No event selected.</div>;

 
  return (

    <Box>
     <PastEventBanner title={event.title} />
          <EventDetails
      time={event.time}
      location={event.location}
      date={event.date}
    />
      <LaundryLeaders title="WHAT EVENT WAS ABOUT?"/>
            <Box
              sx={{
                backgroundImage: `url(${process.env.REACT_APP_IMAGE_BASE_URL}eventsHighlightsBanner.svg)`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                height: "650px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                color: "white",
                mt: 4,
              }}
            > 
              <Typography
                variant="h4"
                fontWeight="bold"
                gutterBottom
                sx={{ ...styles.text1, textTransform: "uppercase" }}
              >
                Highlights from Previous Events
              </Typography>
              <Typography variant="body1" maxWidth="700px" sx={styles.text2}>
                Own a UClean franchise and become a leader in the global laundry
                industry. Our flexible business models and support system ensure a
                seamless start and profitable growth.
              </Typography>
              <Box sx={{ mt: 3 }}>
                <Box
                  component="img"
                  src={`${process.env.REACT_APP_IMAGE_BASE_URL}highlight.svg`}
                  alt="Event Highlight Icon"
                  sx={{
                    width: "100%",
                    height: "auto",
                  }}
                />
                <Typography
                  variant="caption"
                  sx={{ ...styles.text2, fontSize: "12px", mt: 1 }}
                >
                  Laundry Business Seminar in Dubai &nbsp; | &nbsp; Radisson Blu
                  Hotel, Dubai Waterfront
                </Typography>
              </Box>
            </Box>
            <FeedbackComponent/>
            <UpcomingEventsCardsSection/>
     
      <News/>
      <Footer />
    </Box>
  );
};

const styles = {
    text1: {
      fontSize: {
        xs: getResponsiveSize(40 * 0.7),
        sm: getResponsiveSize(40 * 0.8),
        md: getResponsiveSize(40),
      },
      fontFamily: "AllRoundGothicBold, 'Poppins', sans-serif",
      fontWeight: 600,
      color: globalStyles.colors.army_green,
      marginTop: getResponsiveHeight(2),
    },
    text2: {
      fontSize: {
        xs: getResponsiveSize(16),
        sm: getResponsiveSize(18),
        md: getResponsiveSize(20),
      },
      fontFamily: "'Poppins', sans-serif",
      color: globalStyles.colors.uclean_medium_gray,
      marginBottom: getResponsiveHeight(3),
    },
  box1: {
    minHeight: {
      xs: 'auto',
      sm: getResponsiveSize(758),
      md: getResponsiveSize(758),
    },
    width: '100%',
    // py: { xs: 2, sm: 6 },
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    // overflow: 'hidden',
    display: 'flex',
      py:{xs:'16px',md:'10px'}
  },
  contentContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' }, // Column on mobile, row on desktop
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  
  },
  leftBox: {
    width: { xs: '90%', md: '70%', lg: '32%' },

  },
  rightBox: {
    paddingX: { xs: getResponsiveSize(2), md: getResponsiveSize(0) }, // Add padding
    boxSizing: 'border-box', 
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: { xs: '100%', md: '50%', lg: '40%' },
    height: { xs: 'auto', md: '599px'},
  },
  titleWrapper: {
    width: '100%',
    textAlign: 'center',
    mb: { xs: 2, sm: 3 },
    // pl:{xs:getResponsiveSize(2),sm:getResponsiveSize(8)}
  },

  title: {
    color: '#fff',
    fontFamily: ' "Poppins", serif ',
    fontWeight: 800,
    lineHeight: 1,
    textAlign: 'left',
    fontSize: {
      xs: getResponsiveSize(40), // Reduced font size for mobile
      sm: getResponsiveSize(48),
      md: getResponsiveSize(60),
    },
  },
  titleSpan: {
    fontFamily: ' "Poppins", serif ',
    fontWeight: 800,
    display: 'inline',
    textAlign: 'left',
    color: globalStyles.colors.uclean_gold,
    fontSize: {
      xs: getResponsiveSize(40), // Reduced font size for mobile
      sm: getResponsiveSize(48),
      md: getResponsiveSize(60),
    },
  },
  subTitleWrapper: {
    width: '100%',
    textAlign: 'left',
    mb: { xs: 3, sm: 4 },
  },

  subTitle: {
    fontFamily: ' "Poppins", serif ',
    fontWeight: 500,
    fontSize: {
      xs: getResponsiveSize(14), // Reduced font size for mobile
      sm: getResponsiveSize(20),
      md: getResponsiveSize(24),
    },
    color: globalStyles.colors.white,
  },
  subTitleBold: {
    fontFamily: ' "Poppins", serif ',
    fontWeight: 600,
    fontSize: {
      xs: getResponsiveSize(14), // Reduced font size for mobile
      sm: getResponsiveSize(20),
      md: getResponsiveSize(24),
    },
    color: globalStyles.colors.white,
  },
 
};

export default GlobalPastEvent;
